import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { FormGroup, FormControl } from '@angular/forms';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  user: Observable<firebase.User>;
  errorMessageString = '';

  constructor(public afAuth: AngularFireAuth, public fb: FormBuilder, public router: Router) {
    this.user = afAuth.authState;
  }

  public loginForm = new FormGroup({
    email: new FormControl("email", Validators.required),
    password: new FormControl("password", Validators.required)
  });

  ngOnInit() {

    this.loginForm.controls.email.setValue('');
    this.loginForm.controls.password.setValue('');

    var router = this.router;
    this.afAuth.auth.onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        console.log('user signed in');
        router.navigate(['/home']);
      } else {
        // No user is signed in.
        console.log('user signed out');
      }
    });

  }

  loginUser(event) {
    var email = this.loginForm.controls.email.value;
    var password = this.loginForm.controls.password.value;
    var afAuth = this.afAuth;
    var router = this.router;

    var that = this;

    afAuth.auth.signInWithEmailAndPassword(email, password).then(function (res) {
      //success
      console.log('User signed in' + res);
      router.navigate(['/home']);
    }, function(error) {
      // rejection
      var errorMessage = error.message;
      that.errorMessageString = error.message;
      console.log("Error" + errorMessage);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts